var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "general-ledger-view2-multi-currency" }, [
    _c(
      "div",
      {
        staticClass: "section operations",
        staticStyle: { "margin-bottom": "2px" }
      },
      [
        _c(
          "el-form",
          { staticStyle: { "margin-bottom": "-12px" }, attrs: { inline: "" } },
          [
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_FiscalPeriod") } },
              [
                _c(
                  "el-select",
                  {
                    ref: "fromFPRef",
                    staticStyle: { width: "120px" },
                    attrs: { no: "1" },
                    model: {
                      value: _vm.form.fromFP,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fromFP", $$v)
                      },
                      expression: "form.fromFP"
                    }
                  },
                  _vm._l(_vm.fiscalPeriods, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: _vm.fiscalPeriodLabelFun(item),
                        value: item.uuid
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_To") } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "120px" },
                    attrs: { no: "2" },
                    model: {
                      value: _vm.form.toFP,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "toFP", $$v)
                      },
                      expression: "form.toFP"
                    }
                  },
                  _vm._l(_vm.fiscalPeriods, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: _vm.fiscalPeriodLabelFun(item),
                        value: item.uuid
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: { label: _vm.$t("CargoMsg.Cargo_StartingAccountTitle") }
              },
              [
                _c(
                  "el-select",
                  {
                    ref: "accountTitleRef",
                    staticStyle: { width: "300px" },
                    attrs: { filterable: true, clearable: true, no: "3" },
                    model: {
                      value: _vm.form.fromAccountTitle,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "fromAccountTitle", $$v)
                      },
                      expression: "form.fromAccountTitle"
                    }
                  },
                  _vm._l(_vm.accountTitleCollection, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: _vm.accountTitleLabelFun(item),
                        value: item.uuid
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: { label: _vm.$t("CargoMsg.Cargo_ClosureTitleOfAccount") }
              },
              [
                _c(
                  "el-select",
                  {
                    ref: "accountTitleRef",
                    staticStyle: { width: "300px" },
                    attrs: { filterable: true, clearable: true, no: "4" },
                    model: {
                      value: _vm.form.toAccountTitle,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "toAccountTitle", $$v)
                      },
                      expression: "form.toAccountTitle"
                    }
                  },
                  _vm._l(_vm.accountTitleCollection, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: {
                        label: _vm.accountTitleLabelFun(item),
                        value: item.uuid
                      }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c("br"),
            _c(
              "el-form-item",
              { attrs: { label: _vm.$t("CargoMsg.Cargo_Currency") } },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100px" },
                    attrs: { no: "5" },
                    model: {
                      value: _vm.form.sourceCurrency,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "sourceCurrency", $$v)
                      },
                      expression: "form.sourceCurrency"
                    }
                  },
                  _vm._l(_vm.usedCurrencyCollection, function(item) {
                    return _c("el-option", {
                      key: item,
                      attrs: { label: item, value: item }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c("el-checkbox", {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ShowDetailedTitles"),
                    no: "6"
                  },
                  model: {
                    value: _vm.form.showItems,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "showItems", $$v)
                    },
                    expression: "form.showItems"
                  }
                }),
                _c("el-checkbox", {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_ShowAdjustRateEntry"),
                    no: "7"
                  },
                  model: {
                    value: _vm.form.showAdjustRateEntry,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "showAdjustRateEntry", $$v)
                    },
                    expression: "form.showAdjustRateEntry"
                  }
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "el-margin",
                    staticStyle: { "margin-left": "20px" },
                    attrs: { type: "primary", no: "8" },
                    on: { click: _vm.doSearch }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "section", staticStyle: { flex: "1", padding: "0px" } },
      [
        _c("cargo-ag-grid", {
          staticStyle: { height: "800px" },
          attrs: {
            "show-side-bar": false,
            "column-defs": _vm.columnDefs,
            "grid-options": _vm.gridOptions,
            "grid-params": _vm.girdParams,
            "row-data": _vm.rowData,
            "auto-fit-content": false,
            no: "9"
          },
          on: {
            "update:gridParams": function($event) {
              _vm.girdParams = $event
            },
            "update:grid-params": function($event) {
              _vm.girdParams = $event
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }